var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-table-column', _vm._b({ scopedSlots: _vm._u([{ key: "default", fn: function fn(scope) {
        return [_vm._v(_vm._s(Array.isArray(scope.row.tag_list) ? scope.row.tag_list.map(function (item) {
          return item.name;
        }).join(',') : '-'))];
      } }]) }, 'el-table-column', _vm.innerConfig, false));
};
var staticRenderFns = [];

export { render, staticRenderFns };